import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const ArrowUpSlider = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.500"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Path
      d="M17.396 10.132a1 1 0 0 1-.31.72l-4 3.86a1 1 0 0 1-1.4 0l-4-4a1.004 1.004 0 1 1 1.42-1.42l3.29 3.3 3.3-3.18a1 1 0 0 1 1.41 0 1 1 0 0 1 .29.72Z"
      fill={color}
    />
  </Svg>
);

export default ArrowUpSlider;
